import { QueryObserverResult, RefetchOptions, RefetchQueryFilters } from '@tanstack/react-query';

import { RecordingsTable } from './RecordingsTable';
import { getUrlParams } from '../../utils/url';
import { ClassRecording } from '../classroom/types';
import LegacyRecordingsTable from '../legacyRecordings/LegacyRecordingsTable';

type RecordingsProps = {
    userUuid: string;
    classUuid: string;
    isPrivilegedUser: boolean;
    showLegacyRecordings: boolean;
    setRecordings: (recordings: ClassRecording[]) => void;
    recordings: ClassRecording[];
    isFetchingRecordings: boolean;
    isLoadingRecordings: boolean;
    refetchRecordings: <TPageData>(
        options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined
    ) => Promise<QueryObserverResult<ClassRecording[], unknown>>;
};

export const Recordings = (props: RecordingsProps) => {
    const {
        userUuid,
        classUuid,
        isPrivilegedUser,
        showLegacyRecordings,
        recordings,
        setRecordings,
        isLoadingRecordings,
        isFetchingRecordings,
        refetchRecordings
    } = props;

    const { is_guest: isGuestParam } = getUrlParams();

    return !showLegacyRecordings ? (
        <RecordingsTable
            userUuid={userUuid}
            classUuid={classUuid}
            isLoading={isLoadingRecordings}
            isFetching={isFetchingRecordings}
            refetch={refetchRecordings}
            recordings={recordings}
            setRecordings={setRecordings}
            isInstructor={isPrivilegedUser}
            isGuest={isGuestParam === 'true'}
        />
    ) : (
        <LegacyRecordingsTable isLoading={isLoadingRecordings} recordings={recordings} />
    );
};
